import React, { memo, PropsWithChildren } from 'react';

import { Footer, Header, MobileMenu } from '@app/components';

interface LayoutDefaultProps {
  className?: string;
}

function LayoutDefault({
  children,
  className = '',
}: PropsWithChildren<LayoutDefaultProps>) {
  return (
    <div className="min-h-screen flex flex-col bg-[#f5f6fa]">
      <Header />
      <div
        className={`flex-1 w-full max-w-full mx-auto px-0 pb-[60px] md:pb-0 ${className}`.trim()}
      >
        {children}
      </div>
      <Footer />
      <MobileMenu />
    </div>
  );
}

export default memo(LayoutDefault);
